const helpers = window.BASE_HELPERS || {};
const { Mobile } = helpers;

const MODULE = document.querySelectorAll('[data-module="solucoes"]');

class Solucoes {
    constructor() {

        if (!Mobile.isMobile()) {
            this.components = MODULE;
            this.offset = 124
            this.init();
        }
    }

    init() {
        this.components.forEach((component) => {
            this.scrollChangeActive(component);
            this.clickTarget(component);

        });
    }

    scrollChangeActive(component) {
        if (!component) return;
        const itens = component.querySelectorAll('div[data-solucao]');

        if (!itens) return;

        let hasActive = false
        window.addEventListener('scroll', () => {

            itens.forEach(item => {
                const top = item.getBoundingClientRect().top

                if (top <= this.offset) {
                    this.removeAllDivActives(component);
                    item.classList.add('active')
                    hasActive = true
                } else {
                    item.classList.remove('active')
                    hasActive = false;
                }
            })

            if (!hasActive && itens.length) {
                itens[0].classList.add('active');
            }

            const actives = component.querySelectorAll('div[data-solucao].active')

            if (actives) {
                const lastActive = actives[actives.length - 1]
                this.removeAllLinkActives(component);

                const link = component.querySelector(`span[data-solucao="${lastActive.dataset.solucao}"]`);

                if (link) {
                    link.classList.add('active');
                }
            }
        })
    }

    removeAllDivActives(component) {
        if (!component) return;

        const itens = component.querySelectorAll('div[data-solucao]');

        if (!itens) return;

        itens.forEach((item) => {
            item.classList.remove('active');
        });
    }

    removeAllLinkActives(component) {
        if (!component) return;

        const itens = component.querySelectorAll('span[data-solucao]');

        if (!itens) return;

        itens.forEach((item) => {
            item.classList.remove('active');
        });
    }

    clickTarget(component) {
        if (!component) return;

        const itens = component.querySelectorAll('span[data-solucao]');

        if (!itens) return;


        itens.forEach(item => {
            item.addEventListener('click', () => {
                const name = item.dataset.solucao;
                const target = component.querySelector(`#${name}`);

                if (target) {
                    this.scrollToTarget(target)
                }
            })
        })
    }

    scrollToTarget(target) {
        if (!target) return;

        let top =
            target.getBoundingClientRect().top + window.scrollY - this.offset
        top = top + 49;

        window.scrollTo({
            top,
            behavior: 'smooth'
        })
    }
}

(() => {
    if (MODULE) {
        new Solucoes();
    }
})();

export default Solucoes;